/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./resources/js/ecologi-trees.js ***!
  \***************************************/
var trees_total = document.getElementById('trees-num');

if (trees_total) {
  axios.get('https://public.ecologi.com/users/stripeandstareltd/trees', {}).then(function (response) {
    // handle success
    var trees = response.data;
    trees_total.innerHTML = trees.total;
  })["catch"](function (error) {
    // handle error
    window.log(error);
  }).then(function () {// always executed
  });
}
/******/ })()
;